import { render, staticRenderFns } from "./StudentWorks.vue?vue&type=template&id=2d8b1b7e&scoped=true&"
import script from "./StudentWorks.vue?vue&type=script&lang=js&"
export * from "./StudentWorks.vue?vue&type=script&lang=js&"
import style0 from "./StudentWorks.vue?vue&type=style&index=0&id=2d8b1b7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8b1b7e",
  null
  
)

export default component.exports